import React from "react";
import "../styles/Footer.scss";

export function Footer() {
  return (
    <>
      <div className="footer">
        <h4>GET IN TOUCH</h4>
        <div className="line-decoration"></div>
        <p>Please feel free to contact me via email or social media</p>
        <a href="mailto:cladams0203@gmail.com">Contact</a>
      </div>
    </>
  );
}
